import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import request from './plugins/request.js'
Vue.prototype.$H = request

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
Vue.use(ElementUI)
Vue.config.productionTip = false;
Vue.prototype.$store = store

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
